module.exports = __webpack_public_path__ + "img/tema-1-5.7c2fb28d.png";